import React from 'react';

interface GuestLayoutProps {
  children: React.ReactElement;
}

const GuestLayout = ({ children }: GuestLayoutProps) => {
  return (
    <div>
      <div>{children}</div>
    </div>
  );
};

export default GuestLayout;
